import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

type BreadcrumbItem = {
  label: string
  to?: string
}

type HeaderProps = {
  breadcrumbs?: BreadcrumbItem[]
}

const Header = ({ breadcrumbs = [] }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const scrollToSection = (sectionId: string) => {
    const scrollIntoView = () => {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        return true
      }
      return false
    }

    if (location.pathname !== '/') {
      navigate({ pathname: '/', hash: `#${sectionId}` })
      setIsMenuOpen(false)
      return
    }

    if (!scrollIntoView()) {
      setTimeout(scrollIntoView, 50)
    }

    setIsMenuOpen(false)
  }

  const hasBreadcrumbs = breadcrumbs.length > 0

  return (
    <header className={`header ${hasBreadcrumbs ? 'header--with-breadcrumb' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/" aria-label="一般社団法人 日本ITビジネス・プロフェッショナル協会（JITBP）">
              <img src="/images/jitbp_logo_yoko1.png" alt="一般社団法人 日本ITビジネス・プロフェッショナル協会（JITBP）" className="logo-image" />
            </Link>
          </div>
          <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              <li>
                <a
                  href="#home"
                  onClick={(event) => {
                    event.preventDefault()
                    scrollToSection('home')
                  }}
                >
                  ホーム
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  onClick={(event) => {
                    event.preventDefault()
                    scrollToSection('about')
                  }}
                >
                  組織概要
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  onClick={(event) => {
                    event.preventDefault()
                    scrollToSection('services')
                  }}
                >
                  事業内容
                </a>
              </li>
              <li>
                <a
                  href="#news"
                  onClick={(event) => {
                    event.preventDefault()
                    scrollToSection('news')
                  }}
                >
                  お知らせ
                </a>
              </li>
              <li>
                <Link to="/board" onClick={() => setIsMenuOpen(false)}>
                  理事紹介
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </nav>
          <button
            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="メニューを開く"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      {hasBreadcrumbs && (
        <div className="header-breadcrumb">
          <div className="container">
            <ul className="breadcrumb-list" aria-label="パンくずリスト">
              {breadcrumbs.map((item, index) => {
                const key = `${item.label}-${index}`
                if (item.to) {
                  return (
                    <li key={key}>
                      <Link to={item.to}>{item.label}</Link>
                    </li>
                  )
                }
                return <li key={key}>{item.label}</li>
              })}
            </ul>
          </div>
        </div>
      )}
    </header>
  )
}

export default Header

